import removePaymentMethod from '@api/routes/account/RemovePaymentMethod';
import getPaymentMethods from '@api/routes/account/GetPaymentMethods';
import addNewPaymentMethod from '@api/routes/account/AddNewPaymentMethod';
import setDefaultPaymentMethod from '@api/routes/account/SetDefaultPaymentMethod';
import AddPaymentWithaddress from '../add-payment-with-address';


var VCA = VCA || {};

VCA.PaymentManagement = (function ($) {

    var ui = {};
    let config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
    }

    function cacheUI() {
        ui.$tabswrapper = $('.payment-management');
        ui.$setDefaultBtn = $('.js-set-cc-default');
        ui.$deleteBtn = $('.js-delete-cc');
        ui.$cancelBtn = $('.js-cancel-add-payment');
        ui.$submitBtn = $('.js-submit-new-payment');
        ui.$paymentList = $('.js-payment-list');
        ui.$paymentForm = $('.js-add-payment-form');
        ui.$errorMessateSection = $('.js-error-message');
        ui.token = $('#request-verification-token').val();
        ui.loader = $('.payment-management .ajax-loader');
        ui.$noPayment = $('.js-no-payments');
    }

    function init() {
        if ($('.js-payment-management').length <= 0) {
            return;
        }
        cacheUI();
        initGetpayments();
        bindSetDefaultClick();
        bindDeleteClick();
        bindComfirmDeleteClick();
        bindAddPaymentClick();
        bindCancelPaymentClick();
    }

    async function initGetpayments() {

        ui.loader.show();
 
         const { success, data, error }  = await getPaymentMethods.get();
         if(!success){
            console.log('failed', error);
            $('.js-error-message-text').text(error);
            ui.$errorMessateSection.show();
            ui.loader.hide();
            return;
        }else{
            createPaymentList(data);
        }

     };


     function createPaymentList(paymentList) {
         
        ui.$paymentList.empty();
        let paymentCardList = '';

        if(paymentList.length < 1 || paymentList == null){
            ui.$noPayment.show();
        }

        $.each(paymentList, function (i, item) {
            let Default = '';

            if(item.IsDefault) {
                Default = 'js-default-card';
            }

            var date = new Date(parseInt(item.Expiration.substr(6)));
            let month = date.getMonth() + 1;
            let year = date.getFullYear().toString().slice(-2);

            paymentCardList  +=  `
            <div class="myvca-account-box ${Default}"  data-paymentid="${item.Id}">
                <div class="myvca-account-box__cc-info">
                    <img class="myvca-account-box__cc-info__card-img" src="${item.Icon}" alt="Alt Info">
                    <div class="myvca-account-box__cc-info__desc">${item.CardName} *****${item.LastDigits}&nbsp;&nbsp;&nbsp;Exp ${month}/${year}</div>
                    <div class="flag flag-sm bg-color-vca-peach text-color-vca-mud ">Default</div>
                </div>
                <div class="myvca-account-box__action-btns">
                    <div class="d-flex">
                        <button data-paymentid="${item.Id}" data-target="#delete-payment" class="js-set-cc-default myvca-account-box__edit-btn p2">
                            <img src="../../../images-2/edit.svg" alt="Alt Info">
                            Set as Default
                        </button>
                        <button data-paymentid="${item.Id}" class="js-delete-cc myvca-account-box__edit-btn p2">
                            <img src="../../../images-2/edit.svg" alt="Alt Info">
                            Delete
                        </button>
                    </div>
                </div>
            </div>
            `;
        });
        ui.$paymentList.append(paymentCardList);
        ui.loader.hide();

     }

    function bindSetDefaultClick() {
        ui.$tabswrapper.on('click', '.js-set-cc-default', function (e) {
            e.preventDefault();
            ui.loader.show();
            let paymentId = $(this).data('paymentid');
            let el = $(this);
            SetDefaultClick(el,paymentId)
        });
    }

    async function SetDefaultClick(el,paymentId) {
        var params = {"PaymentId":paymentId};
        const { success, data, error }  = await setDefaultPaymentMethod.post(params);
        console.log('success', success);
        console.log('data', data);
        console.log('error', error);
        if(!success){
            console.log('failed', error);
            $('.js-error-message-text').text(error);
            ui.$errorMessateSection.show();
            ui.loader.hide();
            return;
        }else{
           // createPaymentList(data.SavedPayments);
           ui.loader.hide();
           ui.$tabswrapper.find('.js-default-card').removeClass('js-default-card');
           let defaultBox = el.closest('.myvca-account-box');
           defaultBox.parent().prepend(defaultBox);
           defaultBox.addClass('js-default-card');
        }
    }

    function bindDeleteClick() {
        ui.$tabswrapper.on('click', '.js-delete-cc', function (e) {
            e.preventDefault();
            let paymentId = $(this).data('paymentid');
            let el = $(this);
            let card = $(this).closest('.myvca-account-box').find('.myvca-account-box__cc-info');
            $('#delete-payment').modal('show');
            $('#delete-payment .js-delete-payment').empty();
            $('#delete-payment .js-comfrim-delete').attr( "data-paymentid", paymentId );
            card.clone().appendTo('#delete-payment .js-delete-payment');
        });
    }

    function bindComfirmDeleteClick() {
        ui.$tabswrapper.on('click', '.js-comfrim-delete', function (e) {
            e.preventDefault();
            var paymentIdtoDelete = $(this).attr('data-paymentid');
            let card = $('.js-payment-list').find('.myvca-account-box[data-paymentid="' + paymentIdtoDelete + '"]');
            $('#delete-payment').modal('hide');
            ui.loader.show();
            deletePaymentClick(card,paymentIdtoDelete);
        });
    }

    async function deletePaymentClick(card,paymentId) {
        var params = {"PaymentId":paymentId};
        const { success, data, error }  = await removePaymentMethod.post(params);
        console.log('success', success);
        console.log('data', data);
        console.log('error', error);
        if(!success){
            console.log('failed', error);
            $('.js-error-message-text').text(error);
            ui.$errorMessateSection.show();
            ui.loader.hide();
            return;
        }else{
           ui.loader.hide();
           card.remove();
        }
    }

    function bindAddPaymentClick() {
        ui.$tabswrapper.on('click', '.js-add-payment-method', function (e) {
            e.preventDefault();
            ui.$paymentList.hide();
            ui.$noPayment.hide();
            ui.$paymentForm.show();

            let getpaymentform = new AddPaymentWithaddress({
                containerId: '#addpayment-form-wrapper',
                formId: '#form-wrapper',
                paymentFrameContainerId: 'paymentFrameContainer',
                savePaymentId: '#savePayment',
                paymentLoaderId: '#paymentLoader',
                settingsId: '#paymentSettings',
                updateAutoshipCheckboxId: '#active-subscriptions',
                urlPath: '/api/account/AddNewPaymentMethod'
            });
        });
    }

    function bindCancelPaymentClick() {
        ui.$tabswrapper.on('click', '.js-cancel-add-payment', function (e) {
            // e.preventDefault();
            // ui.$paymentForm.hide();
            // ui.$paymentList.show();
            window.location.reload(); //Note: Due to XSS protection, we cannot clear the credit card input values since it is on a different domain. Instead we will be refreshing the page on cancel click.
        });
    }

    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.PaymentManagement.init();
});